import React, { lazy } from "react";

const LazyCreateContact = lazy(() => import("./CreateContact"));

const CreateContact = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyCreateContact {...props} />;

export default CreateContact;
